import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import IdentityTableHead from '../../components/molecules/IdentityTableHead';
import IdentityTableBody from '../../components/molecules/IdentityTableBody';
import IdentityRegister from './IdentityRegister';
import IdentityApproval from './IdentityApproval';
// import TablePagination from '../../components/molecules/TablePagination';
import { getIdentities, editIdentityStatus } from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';
import ExPagination from '../../components/molecules/ExPagination';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      identities: state.identities.identities,
      totalCount: state.identities.totalCount,
      offset: state.identities.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getIdentities, editIdentityStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityId', 'setIdentityId', null),
  withState('shopId', 'setShopId', null),
  withState('sealCertificate', 'setSealCertificate', null),
  withState('businessLicense', 'setBusinessLicense', null),
  withState('registeredCopy', 'setRegisterCopy', null),
  withState('citizenIdentityCard', 'setCitizenIdentityCard', null),
  withState('other', 'setOther', null),
  withState('note', 'setNote', null),
  withState('numberIdentity', 'setNumberIdentity', null),
  withState('shopFood', 'setShopFood', null),
  withState('shopFoodApproved', 'setShopFoodApproved', null),
  withState('adminMemo', 'setAdminMemo', null),
  withState('status', 'setStatus', null),
  withState('phone', 'setPhone', null),
  withState('email', 'setEmail', null),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('ngReason', 'setNgReason', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('identityImages', 'setIdentityImages', []),
  withState('registeredCopyImage', 'setRegisteredCopyImage', []),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    identities,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    openRegisterModal,
    updateOpenRegisterModal,
    openApprovalModal,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    rowsPerPage,
    handleChangeRowsPerPage,
    identityId,
    setIdentityId,
    shopId,
    setShopId,
    sealCertificate,
    setSealCertificate,
    businessLicense,
    setBusinessLicense,
    registeredCopy,
    setRegisterCopy,
    other,
    setOther,
    note,
    shopFood,
    setShopFood,
    shopFoodApproved,
    setShopFoodApproved,
    setNote,
    adminMemo,
    setAdminMemo,
    status,
    setStatus,
    targetRowId,
    setTargetRowId,
    phone,
    email,
    setPhone,
    setEmail,
    order,
    orderBy,
    handleRequestSort,
    ngReason,
    setNgReason,
    bankAccountHolder,
    setBankAccountHolder,
    numberIdentity,
    setNumberIdentity,
    citizenIdentityCard,
    setCitizenIdentityCard,
    identityImages,
    setIdentityImages,
    registeredCopyImage,
    setRegisteredCopyImage
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      identityId,
      shopId,
      bankAccountHolder,
      sealCertificate,
      businessLicense,
      registeredCopy,
      other,
      note,
      shopFood,
      shopFoodApproved,
      adminMemo,
      ngReason,
      status,
      phone,
      email,
      numberIdentity,
      citizenIdentityCard,
      identityImages
    };

    const registerOpenAction = params => {
      updateOpenRegisterModal(true);
      setTargetRowId(params.id);
      setBankAccountHolder(params.bankAccountHolder);
      setRegisteredCopyImage(params.registeredCopyImage);
    };
    const confirmOpenAction = async params => {
      setIdentityId(params.identityId);
      setShopId(params.shopId);
      setSealCertificate(params.sealCertificate);
      setBusinessLicense(params.businessLicense);
      setCitizenIdentityCard(params.citizenIdentityCard);
      setRegisterCopy(params.registeredCopy);
      setOther(params.other);
      setNote(params.note);
      setNumberIdentity(params.numberIdentity);
      setShopFood(params.shopFood);
      setShopFoodApproved(params.shopFoodApproved);
      setAdminMemo(params.adminMemo);
      setNgReason(params.ngReason);
      setStatus(params.status);
      setPhone(params.phone);
      setEmail(params.email);
      setBankAccountHolder(params.bankAccountHolder);
      setIdentityImages(params.identityImages);
      updateOpenApprovalModal(true);
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <IdentityTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <IdentityTableBody
              identities={identities}
              emptyRows={emptyRows}
              page={page}
              orderBy={orderBy}
              order={order}
              rowsPerPage={rowsPerPage}
              registerOpenAction={registerOpenAction}
              confirmOpenAction={confirmOpenAction}
              updateOpenRegisterModal={updateOpenRegisterModal}
              updateOpenConfirmModal={updateOpenApprovalModal}
              setTargetRowId={setTargetRowId}
              roles={roles}
            />
          </Table>
        </div>
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={identities}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        )}
        <Modal open={openRegisterModal}>
          <IdentityRegister
            updateOpenRegisterModal={updateOpenRegisterModal}
            searchKey={searchKey}
            targetRowId={targetRowId}
            bankAccountHolder={bankAccountHolder}
            setBankAccountHolder={setBankAccountHolder}
            registeredCopyImage={registeredCopyImage}
          />
        </Modal>
        <Modal open={openApprovalModal}>
          <IdentityApproval
            updateOpenApprovalModal={updateOpenApprovalModal}
            openApprovalConfirmModal={openApprovalConfirmModal}
            updateOpenApprovalConfirmModal={updateOpenApprovalConfirmModal}
            detail={detail}
            targetRowId={targetRowId}
            searchKey={searchKey}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
